
import { PaginatedVotingHistoryTable } from "./history/PaginatedVotingHistoryTable";
import { VerificationHistoryTable } from "./history/VerificationHistoryTable";

export const UserHistory = ({ userId }: { userId?: string }) => {
  return (
    <div className="space-y-8">
      <PaginatedVotingHistoryTable userId={userId} />
      <VerificationHistoryTable userId={userId} />
    </div>
  );
};
